import React, { useEffect } from "react";
import { StyledHeader, StyledHeaderLogo } from "./styles";
import logo from "../../assets/header_app_logo.png";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Popupmenu } from "../UI/PopupMenu";
import { HEADER_ACTION_OPTIONS } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../Auth/hooks/useAuth";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { userActions } from "../../store/actions";
import { useUpdateCount } from "./updateCount";

const Header = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((store) => store.user).authInfo || {};
  const sidebar = useSelector((store) => store.user).sidebar;
  const notificationCount = useSelector(
    (store) => store.user
  ).notificationCount;
  const { logoutUser } = useAuth();
  const { ResourceName } = userInfo ?? {};
  const dispatch = useDispatch();
  const updateCount = useUpdateCount();
  const profileClickHandler = () => {
    navigate(SITE_LINKS_SCHEMA.PROFILE);
  };
  const helpClickHandler = () => {
    window.open(process.env.REACT_APP_HELP_PAGE_LINK, "_blank");
  };
  const notificationsClickHandler = () => {
    navigate(SITE_LINKS_SCHEMA.NOTIFICATIONS);
  };
  const actionClickMapping = {
    logout: logoutUser,
    profile: profileClickHandler,
    help: helpClickHandler,
  };

  useEffect(() => {
    updateCount();
  }, []);

  return (
    <StyledHeader>
      <StyledHeaderLogo>
        <Link to="/" onClick={() => dispatch(userActions.setSidebar(false))}>
          <img src={logo} alt="company-logo" />
        </Link>
        {sidebar && document.title !== "Notifications" ? (
          <CloseIcon
            onClick={() => dispatch(userActions.setSidebar(!sidebar))}
          />
        ) : (
          document.title !== "Notifications" && (
            <MenuIcon
              onClick={() => dispatch(userActions.setSidebar(!sidebar))}
            />
          )
        )}
      </StyledHeaderLogo>
      <div className="time_mngmt__header_actions">
        <span className="userName">{ResourceName}</span>
        <span
          className="time_mngmt__header_icon time_mngmt-notifications_icon"
          onClick={notificationsClickHandler}
        >
          <NotificationsNoneIcon />
          <span className="icon-button__badge">{notificationCount}</span>
        </span>
        <span className="time_mngmt__header_icon time_mngmt__profile_icon">
          <Popupmenu
            TriggerComponent={PersonOutlineIcon}
            popupOptions={HEADER_ACTION_OPTIONS}
            label={""}
            onOptionSelect={(option) => {
              typeof actionClickMapping[option.key] === "function" &&
                actionClickMapping[option.key].call(this);
            }}
          />
        </span>
      </div>
    </StyledHeader>
  );
};

export default Header;
